
export default {
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
    fixture: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  inject: [`lastUpdated`],
};
